import JSONUtils from '../../lib/JSONUtils';
import safeNotifyPopupOpener from '../../lib/safeNotifyPopupOpener';

export default function BoxAuthenticator() {
  let url = window.location.href;
  let protocol = window.location.protocol;
  let host = window.location.host;
  let responseParams = url.replace(`${protocol}//${host}/boxAuth?`, '');

  let queryJSON = JSONUtils.queryStringToJSON(responseParams);

  if (queryJSON) {
    safeNotifyPopupOpener(queryJSON, null);
    window.location.replace('about:blank');
    window.close();
  } else {
    safeNotifyPopupOpener(null, 'Box authentication error');
    window.location.replace('about:blank');
    window.close();
  }
  return null;
}
